import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import CategoryTabs from '@/components/base/CategoryTabs';
import DomainCard from '@/components/base/DomainCard';
import { articles, categories, hotTags } from '@/mocks/articles';
import { domains, siteInfo } from '@/mocks/domains';
import { faqs } from '@/mocks/faqs';

export default function Home() {
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);

  useEffect(() => {
    document.title = `${siteInfo.name}永久域名 | 最新不封地址入口 - 黑料网`;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', siteInfo.description);
    const metaKw = document.querySelector('meta[name="keywords"]');
    if (metaKw) metaKw.setAttribute('content', siteInfo.keywords);
  }, []);

  const hotArticles = articles.filter((a) => a.isHot).slice(0, 6);
  const latestArticles = articles.slice(0, 9);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: 'https://heiliaowang.com',
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://heiliaowang.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full pt-16">
            <div className="relative w-full h-[500px] md:h-[600px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20cityscape%20at%20night%20with%20glowing%20neon%20red%20and%20amber%20lights%2C%20dramatic%20cinematic%20atmosphere%2C%20foggy%20streets%2C%20modern%20urban%20landscape%2C%20high%20contrast%20photography%20with%20deep%20shadows%2C%20editorial%20style&width=1600&height=900&seq=hero-main-01&orientation=landscape"
                alt="黑料网永久域名入口"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-full max-w-4xl mx-auto px-4 text-center">
                  <h1 className="font-heading text-3xl md:text-5xl text-background-50 mb-4 leading-tight">
                    黑料网永久域名
                  </h1>
                  <p className="text-base md:text-lg text-background-200/80 mb-8 max-w-2xl mx-auto leading-relaxed">
                    整理黑料网最新永久可用域名入口，实时更新防封地址，告别频繁换域烦恼，收藏本页即可随时稳定访问
                  </p>
                  <div className="flex flex-wrap items-center justify-center gap-3 mb-6">
                    {hotTags.slice(0, 8).map((tag) => (
                      <span
                        key={tag}
                        className="px-3 py-1 text-sm rounded-full bg-background-50/15 text-background-100 border border-background-50/20 backdrop-blur-sm cursor-pointer hover:bg-background-50/25 transition-all whitespace-nowrap"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/20 border border-accent-400/30 text-accent-200 text-sm">
                    <i className="ri-flashlight-line animate-pulse"></i>
                    <span>实时更新 · 最后检查：2025-08-07</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Domain Entry Section */}
          <section className="relative -mt-10 z-10">
            <div className="max-w-4xl mx-auto px-4 md:px-6">
              <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 space-y-3">
                <div className="flex items-center justify-between mb-2">
                  <h2 className="font-heading text-lg text-foreground-900 flex items-center gap-2">
                    <i className="ri-link-m text-primary-500"></i>
                    最新可用域名入口
                  </h2>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-checkbox-circle-fill text-emerald-500"></i>
                    {domains.length}个域名全部可用
                  </span>
                </div>
                <div className="grid gap-2">
                  {domains.map((domain) => (
                    <DomainCard key={domain.url} domain={domain} />
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Hot Articles Section */}
          <section className="py-14">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="font-heading text-2xl text-foreground-900 mb-1">
                    <i className="ri-fire-fill text-accent-500 mr-2"></i>
                    热门爆料
                  </h2>
                  <p className="text-sm text-foreground-500">全网最火爆的深度调查报道</p>
                </div>
                <Link
                  to="/category/all"
                  className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  查看全部 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {hotArticles.map((article) => (
                  <ArticleCard key={article.slug} article={article} />
                ))}
              </div>
            </div>
          </section>

          {/* Category Navigation */}
          <section className="py-10 bg-background-100">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="text-center mb-6">
                <h2 className="font-heading text-2xl text-foreground-900 mb-2">按分类浏览</h2>
                <p className="text-sm text-foreground-500">选择你感兴趣的资讯分类，发现更多精彩内容</p>
              </div>
              <div className="flex justify-center">
                <CategoryTabs active="all" />
              </div>
            </div>
          </section>

          {/* Latest Articles */}
          <section className="py-14">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="font-heading text-2xl text-foreground-900 mb-1">
                    <i className="ri-newspaper-line text-primary-500 mr-2"></i>
                    最新资讯
                  </h2>
                  <p className="text-sm text-foreground-500">实时更新的热点资讯和深度爆料</p>
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {latestArticles.map((article) => (
                  <ArticleCard key={article.slug} article={article} />
                ))}
              </div>
            </div>
          </section>

          {/* Stats Section */}
          <section className="py-14 bg-background-100">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
                {[
                  { number: '5000万+', label: '月活跃用户', icon: 'ri-user-line' },
                  { number: '2000万+', label: '日均浏览量', icon: 'ri-eye-line' },
                  { number: '10万+', label: '累计报道', icon: 'ri-article-line' },
                  { number: '99.7%', label: '域名可用率', icon: 'ri-shield-check-line' },
                ].map((stat) => (
                  <div key={stat.label} className="text-center">
                    <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-2xl bg-primary-100">
                      <i className={`${stat.icon} text-2xl text-primary-600`}></i>
                    </div>
                    <div className="font-heading text-2xl text-foreground-900 mb-1">{stat.number}</div>
                    <div className="text-sm text-foreground-500">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* FAQ Section */}
          <section className="py-14">
            <div className="max-w-3xl mx-auto px-4 md:px-6">
              <div className="text-center mb-8">
                <h2 className="font-heading text-2xl text-foreground-900 mb-2">常见问题</h2>
                <p className="text-sm text-foreground-500">关于黑料网域名的常见问题解答</p>
              </div>
              <div className="space-y-3">
                {faqs.map((faq, index) => (
                  <div
                    key={index}
                    className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
                  >
                    <button
                      onClick={() => setOpenFaqIndex(openFaqIndex === index ? null : index)}
                      className="w-full flex items-center justify-between p-4 text-left cursor-pointer hover:bg-background-50/80 transition-colors"
                    >
                      <span className="font-medium text-sm text-foreground-900 pr-4">
                        {faq.question}
                      </span>
                      <i
                        className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-200 flex-shrink-0 ${
                          openFaqIndex === index ? 'rotate-180' : ''
                        }`}
                      ></i>
                    </button>
                    {openFaqIndex === index && (
                      <div className="px-4 pb-4">
                        <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Bottom CTA */}
          <section className="py-14 bg-gradient-to-b from-background-100 to-background-50">
            <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-accent-100">
                <i className="ri-bookmark-3-fill text-3xl text-accent-500"></i>
              </div>
              <h2 className="font-heading text-2xl text-foreground-900 mb-3">
                收藏本页 · 永不迷路
              </h2>
              <p className="text-sm text-foreground-500 mb-6 leading-relaxed">
                按 <kbd className="px-1.5 py-0.5 text-xs bg-background-200 rounded border border-background-300 font-sans">Ctrl + D</kbd> 收藏本页面，随时获取黑料网最新永久域名，安全快速直达。
              </p>
              <div className="flex flex-wrap items-center justify-center gap-3">
                {categories.filter((c) => c.slug !== 'all').slice(0, 3).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className={`${cat.icon} mr-1.5`}></i>浏览{cat.name}
                  </Link>
                ))}
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}